import type { AiContestWorkType } from "../types";

/** 作品类型选项（与后端枚举一致）。 */
export const AI_CONTEST_WORK_TYPE_OPTIONS: Array<{
  value: AiContestWorkType;
  label: string;
}> = [
  { value: "heritage_creative", label: "非遗文创" },
  { value: "ip_creative", label: "IP文创" },
  { value: "original_handmade", label: "原创手作" },
];

/** 页面标题。 */
export const AI_CONTEST_PAGE_TITLE = "活路儿非遗创意作品线下展";
